import React, { useEffect, useState } from "react";
import AcUnitIcon from "@mui/icons-material/AcUnit";
import { styled } from "@mui/system";
import FavoriteIcon from "@mui/icons-material/Favorite";
import snowflake from "../images/snowflake.svg";

const SnowContainer = styled("div")({
  width: "100%",
  height: "100vh",
  pointerEvents: "none",
  zIndex: 99,
  position: "fixed",
  top: 0,
  left: 0,
});

const Snowflake = styled("div")({
  position: "absolute",
  top: "-50px",
  fontSize: "2rem",
  color: "#FFF",
  animationName: "snow",
  animationTimingFunction: "linear",
  animationIterationCount: "infinite",
  "@keyframes snow": {
    "0%": { transform: "translateY(-50px)" },
    "100%": { transform: "translateY(calc(100vh + 50px))" },
  },
});

const SnowingEffect = () => {
  const [flakes, setFlakes] = useState([]);

  const createSnowflakes = () => {
    const numberOfFlakes = 160;
    let flakesArray = [];
    for (let i = 0; i < numberOfFlakes; i++) {
      flakesArray.push({
        id: i,
        left: `${Math.random() * 160}vw`,
        animationDuration: `${Math.random() * 3 + 3}s`,
        animationDelay: `${Math.random() * 5}s`,
        opacity: Math.random() * 0.5 + 0.3,
      });
    }
    setFlakes(flakesArray);
  };

  useEffect(() => {
    createSnowflakes();
    const intervalId = setInterval(createSnowflakes, 7000);
    return () => clearInterval(intervalId);
  }, []);

  return (
    <SnowContainer>
      {flakes.map((flake) => (
        <Snowflake
          key={flake.id}
          style={{
            left: flake.left,
            animationDuration: flake.animationDuration,
            animationDelay: flake.animationDelay,
            opacity: flake.opacity,
          }}
        >
          <img
            src={snowflake}
            alt="Snowflake"
            style={{
              width: "16px",
              height: "16px",
              filter: "invert(100%)", // Makes the SVG white
            }}
          />
        </Snowflake>
      ))}
    </SnowContainer>
  );
};

export default SnowingEffect;
